import {
  easeInQuad,
  easeOutQuad,
  easeInOutQuad,
  easeInCubic,
  easeOutCubic,
  easeInOutCubic,
  easeInQuart,
  easeOutQuart,
  easeInOutQuart,
  easeInQuint,
  easeOutQuint,
  easeInOutQuint,
  easeInSine,
  easeOutSine,
  easeInOutSine,
  easeInExpo,
  easeOutExpo,
  easeInOutExpo,
  easeInCirc,
  easeOutCirc,
  easeInOutCirc,
  easeInElastic,
  easeOutElastic,
  easeInOutElastic,
  easeInBack,
  easeOutBack,
  easeInOutBack,
  easeInBounce,
  easeOutBounce,
  easeInOutBounce,
} from 'js-easing-functions';

function easeLinear(elapsed: number, initialValue: number, amountOfChange: number, duration: number): number {
  return amountOfChange * (elapsed / duration) + initialValue;
}

class Easing {
  static fn = {
    easeLinear,
    easeInQuad,
    easeOutQuad,
    easeInOutQuad,
    easeInCubic,
    easeOutCubic,
    easeInOutCubic,
    easeInQuart,
    easeOutQuart,
    easeInOutQuart,
    easeInQuint,
    easeOutQuint,
    easeInOutQuint,
    easeInSine,
    easeOutSine,
    easeInOutSine,
    easeInExpo,
    easeOutExpo,
    easeInOutExpo,
    easeInCirc,
    easeOutCirc,
    easeInOutCirc,
    easeInElastic,
    easeOutElastic,
    easeInOutElastic,
    easeInBack,
    easeOutBack,
    easeInOutBack,
    easeInBounce,
    easeOutBounce,
    easeInOutBounce,
  };

  private startTime: number = 0;

  private readonly ease: Function;

  private readonly startValue: number;

  private readonly endValue: number;

  private readonly duration: number;

  private readonly stepCallback: (_value: number) => void;

  private endCallback: ((_value: number) => void) | null = null;

  private playing: boolean = false;

  constructor(ease: Function, startValue: number, endValue: number, duration: number, stepCallback: (_value: number) => void) {
    this.ease = ease;
    this.startValue = startValue;
    this.endValue = endValue;
    this.duration = duration;
    this.stepCallback = stepCallback;
  }

  public start = (endCallback: ((_value: number) => void) | null = null) => {
    this.endCallback = endCallback;
    this.startTime = Date.now();
    this.playing = true;
    requestAnimationFrame(this.step);
    return {
      break: () => {
        this.playing = false;
      },
    };
  };

  private step = () => {
    const elapsed = Date.now() - this.startTime;

    this.stepCallback(this.ease(elapsed, this.startValue, this.endValue - this.startValue, this.duration));

    if (elapsed >= this.duration || !this.playing) {
      if (this.endCallback) {
        this.endCallback(this.endValue);
      }
      return;
    }

    requestAnimationFrame(this.step);
  };
}

export default Easing;
